module.exports = __webpack_public_path__ + "static/media/img_welcome-_bg_patient.945875ec.png";